module.exports = __webpack_public_path__ + "img/new-dedicated.8503af53.svg";